import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { DrugAlcoholRecordHttpClient } from 'src/app/shared/flight-log-api/drug-alcohol-records/drug-alcohol-records-client.service';
import {
  CommandError,
  CommandResult,
  CommandResultStatus,
} from 'src/app/shared/flight-log-api/shared/shared-client.model';
import { PilotDrugAlcoholRecordFormComponent } from '../pilot-drug-alcohol-record-form/pilot-drug-alcohol-record-form.component';

@Component({
  selector: 'fl-pilot-drug-alcohol-record-add-dialog',
  templateUrl: './pilot-drug-alcohol-record-add-dialog.component.html',
  styleUrls: ['./pilot-drug-alcohol-record-add-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PilotDrugAlcoholRecordAddDialogComponent implements OnInit {
  public onDestroy$ = new Subject();
  @ViewChild(PilotDrugAlcoholRecordFormComponent)
  public pilotDrugAlcoholRecordFormCmp: PilotDrugAlcoholRecordFormComponent;
  public clicked = false;
  public errors$: Subject<CommandError[]> = new Subject<CommandError[]>();

  constructor(
    private _drugAlcoholRecord: DrugAlcoholRecordHttpClient,
    private _snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<PilotDrugAlcoholRecordAddDialogComponent>,
  ) {}

  public ngOnInit() {}

  public async add() {
    const result = (await this._drugAlcoholRecord
      .create(this.pilotDrugAlcoholRecordFormCmp.form.value, this.data.pilotId)
      .toPromise()) as CommandResult;
    if (result.errors.length > 0) {
      this._snackBar.open('Error creating pilot drug and alcohol record.', undefined, {
        duration: 2000,
      });
      this.errors$.next(result.errors);
      this.clicked = false;
    }

    if (result.errors.length === 0 && result.status === CommandResultStatus.Succeeded) {
      this._snackBar.open('Succesfully created pilot drug and alcohol record.', undefined, {
        duration: 2000,
      });
      this.dialogRef.close();
    }
  }
}
